/**
 * Plays the fw-video band's clip only while the whole band is in frame, and the tile row's
 * clips while on screen: those start when a quarter of the row enters the viewport and pause
 * when it leaves.
 * The clips carry no audio track and are muted besides.
 */
(() => {
  const wire = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // posters only
    // Desktop tile clips play one at a time, in order, looping round; hovering a tile hands
    // the sequence to it. Phones play in view (below).
    const hoverTiles = window.matchMedia('(hover: hover) and (min-width: 900px)').matches;
    const tiles = [...document.querySelectorAll('.fw-steps__video')];
    if (hoverTiles && tiles.length && tiles[0].dataset.fwWired !== 'true') {
      tiles.forEach((v) => { v.dataset.fwWired = 'true'; v.loop = false; });
      let current = -1;
      // Moving to another tile pauses the last one on the frame it was showing (no jump back
      // to its first frame); a tile picks up where it paused, and starts over only once it
      // has played to the end.
      const playAt = (i) => {
        if (current >= 0 && current !== i) tiles[current].pause();
        current = i;
        const v = tiles[i];
        if (v.ended || (v.duration && v.currentTime >= v.duration - 0.05)) v.currentTime = 0;
        v.play().catch(() => {});
      };
      tiles.forEach((v, i) => {
        v.addEventListener('ended', () => { if (current === i) playAt((i + 1) % tiles.length); });
        (v.closest('.fw-steps__tile') || v).addEventListener('mouseenter', () => { if (current !== i) playAt(i); });
      });
      // Start the sequence when the row scrolls in; pause it when the row leaves.
      const row = tiles[0].closest('.fw-steps') || tiles[0];
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { if (current < 0) playAt(0); else tiles[current].play().catch(() => {}); }
          else if (current >= 0) tiles[current].pause();
        });
      }, { threshold: 0.25 }).observe(row);
    }
    // The band's clip plays only while the whole band is in frame below the sticky header,
    // so its transitions aren't missed half off screen (1 Nov 2026). Observed on the band,
    // not the video: the phone clip is scaled 1.12 inside it, so its own box never fits.
    // A band taller than the room under the header plays once as much of it as fits shows.
    document.querySelectorAll('.fw-video').forEach((band) => {
      if (band.dataset.fwWired === 'true') return;
      const clips = [...band.querySelectorAll('video')];
      if (!clips.length) return;
      band.dataset.fwWired = 'true';
      clips.forEach((v) => { v.dataset.fwWired = 'true'; });
      const header = document.getElementById('header-component');
      const top = header ? Math.round(header.getBoundingClientRect().height) : 0;
      // The share needed is worked out on every check, not once at load (the band's
      // height isn't final then, and a phone's toolbar changes the room as it scrolls).
      const steps = Array.from({ length: 101 }, (_, i) => i / 100);
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const room = e.rootBounds ? e.rootBounds.height : window.innerHeight - top;
          const h = e.boundingClientRect.height || 1;
          const need = Math.min(1, room / h) - 0.02;
          const full = e.isIntersecting && e.intersectionRatio >= need;
          clips.forEach((v) => {
            if (v.offsetParent === null) return; // the other breakpoint's clip
            if (full) v.play().catch(() => {});
            else v.pause();
          });
        });
      }, { threshold: steps, rootMargin: `-${top}px 0px 0px 0px` }).observe(band);
    });

    const videos = document.querySelectorAll(hoverTiles ? '.fw-video video' : '.fw-video video, .fw-steps__video');
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Muted playback; the promise rejects harmlessly if the browser
            // declines (e.g. data-saver mode).
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((video) => {
      if (video.dataset.fwWired === 'true') return;
      video.dataset.fwWired = 'true';
      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
